// src/hooks/nationalities/useDeleteNationalities.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteNationality } from "../../api/apiNationalities";
import parseError from "../../utils/parseError";

const useDeleteNationalities = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteNationalities, isPending: isDelete } = useMutation({
        mutationFn: deleteNationality,
        onSuccess: (res) => {
            const message = res?.message || "Nationality deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["nationalities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete nationality");
        },
    });

    return { deleteNationalities, isDelete };
};

export default useDeleteNationalities;